export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(
    Number(n || 0)
  );

export const num = (n) => new Intl.NumberFormat("en-IN").format(Number(n || 0));

export const dt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  admin: "Ops Admin",
  distributor: "Distributor",
  merchant: "Merchant",
};
